import styled from 'styled-components'
import Recipes from '../Shared/recipes'

export const GridContainer = styled(Recipes)`

`